import { useReveal, reveal } from '../hooks/useReveal';

export default function Footer() {
  const [footerRef, isRevealed] = useReveal({ threshold: 0.1 });

  return (
    <footer className="relative -mx-6 sm:-mx-10 lg:-mx-16">
      {/* Dark background - bookends with Precurion */}
      <div className="absolute inset-0 bg-foreground"></div>

      <div
        ref={footerRef}
        className="relative px-6 sm:px-10 lg:px-16 pt-32 md:pt-40 pb-16 md:pb-20"
      >
        <div className="max-w-screen-xl mx-auto">
          {/* The close - make it a moment */}
          <div id="contact" className="max-w-4xl mb-20">
            <div className={`flex items-center gap-4 mb-8 ${reveal(isRevealed)}`}>
              <div className="w-16 h-1.5 bg-accent"></div>
              <p className="text-caption uppercase tracking-widest" style={{ color: 'rgba(250, 250, 248, 0.6)' }}>Let's Connect</p>
            </div>

            <h2 className={`text-display-lg text-background mb-8 ${reveal(isRevealed)}`} style={{ '--d': '60ms' }}>
              Build with me.
            </h2>

            <p className={`text-statement max-w-2xl mb-12 ${reveal(isRevealed)}`} style={{ color: 'rgba(250, 250, 248, 0.6)', '--d': '120ms' }}>
              I'm looking for investors, collaborators, and people with high agency
              who love solving hard problems.
            </p>

            {/* CTA - prominent */}
            <a
              href="mailto:nicolai@precurion.com"
              className={`group inline-flex items-center gap-4 px-8 py-5 bg-accent text-foreground text-body font-medium no-underline hover:bg-background hover:text-foreground btn-magnetic ${reveal(isRevealed)}`}
              style={{ '--d': '180ms' }}
            >
              <span>nicolai@precurion.com</span>
              <svg className="w-5 h-5 transform transition-transform duration-200 group-hover:translate-x-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
          </div>

          {/* Social + info row */}
          <div className={`grid grid-cols-1 md:grid-cols-3 gap-12 pt-16 border-t ${reveal(isRevealed)}`} style={{ borderColor: 'rgba(250, 250, 248, 0.2)', '--d': '200ms' }}>
            {/* Statement */}
            <div>
              <p className="text-body" style={{ color: 'rgba(250, 250, 248, 0.6)' }}>
                I work because I think it's fun—not because I have to. I want to
                be around people who feel the same way.
              </p>
            </div>

            {/* Links */}
            <div className="flex flex-col gap-3">
              <a
                href="https://www.linkedin.com/in/nicolai-herforth/"
                target="_blank"
                rel="noreferrer"
                className="text-body text-background text-opacity-60 hover:text-background no-underline transition-colors duration-200"
              >
                LinkedIn →
              </a>
              <a
                href="https://github.com/NicolaiHerforth"
                target="_blank"
                rel="noreferrer"
                className="text-body text-background text-opacity-60 hover:text-background no-underline transition-colors duration-200"
              >
                GitHub →
              </a>
              <a
                href="https://x.com/NicolaiHerforth"
                target="_blank"
                rel="noreferrer"
                className="text-body text-background text-opacity-60 hover:text-background no-underline transition-colors duration-200"
              >
                X / Twitter →
              </a>
            </div>

            {/* Location */}
            <div className="md:text-right">
              <p className="text-body text-background mb-1">Copenhagen & New York</p>
              <p className="text-caption" style={{ color: 'rgba(250, 250, 248, 0.6)' }}>Building in public</p>
            </div>
          </div>

          {/* Signature close - editorial moment */}
          <div className="mt-16 pt-12 border-t" style={{ borderColor: 'rgba(250, 250, 248, 0.2)' }}>
            <p
              className="font-display text-center mb-8"
              style={{
                fontSize: 'clamp(1.5rem, 3vw, 2rem)',
                color: 'rgba(250, 250, 248, 0.5)',
                fontStyle: 'italic',
                letterSpacing: '-0.01em'
              }}
            >
              The hard part isn't execution.
            </p>

            {/* Copyright */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-accent"></div>
                <p className="text-caption" style={{ color: 'rgba(250, 250, 248, 0.6)' }}>Nicolai Herforth</p>
              </div>
              <p className="text-caption" style={{ color: 'rgba(250, 250, 248, 0.6)' }}>© 2026</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
